import * as Elastic from '@elastic/app-search-javascript';
export default class StockConfiguration {
    constructor(APP_ROOT_ELEMENT) {
        this.APP_ROOT_ELEMENT = APP_ROOT_ELEMENT;
        this.dataset = APP_ROOT_ELEMENT.dataset;
        this.locale = this.dataset.currentLocale.replace('_', '-');
        this.currentLocale = this.dataset.currentLocale;
        this.overviewSlug = this.dataset.overviewSlug || 'voorraad';
        this.testdriveLink = this.dataset.testdriveLink;
        this.contactLink = this.dataset.contactLink;
        this.quotationLink = this.dataset.quotationLink;
        this.client = Elastic.createClient({
            searchKey: 'search-ehbdmvnimxbxtfki9qxov4ua',
            endpointBase: 'https://search.vanmossel.com',
            engineName: `${this.dataset.environment}-hexonmaxus`,
        });
    }
    getRawDataSet() {
        return this.dataset;
    }
    get country() {
        var _a;
        return (_a = this.locale) === null || _a === void 0 ? void 0 : _a.split('-')[1];
    }
    get language() {
        var _a;
        return (_a = this.locale) === null || _a === void 0 ? void 0 : _a.split('-')[0];
    }
}
